<template>
	<v-flex>
		<v-checkbox
				:label="$props.label"
				class="ml-2 mr-2"
				v-model="inputValue"></v-checkbox>
	</v-flex>
</template>

<script>
	export default {
		name: "CheckBox",
		props: ['value', 'label'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
</style>